/* PLOP_INJECT_IMPORT */
import { renderComponent } from 'utils/RenderingUtils';
import { IMappingEditorDialogProps } from './MappingEditor/MappingEditorDialog';

export async function renderMappingEditor(container: HTMLElement, props: IMappingEditorDialogProps) {
  const { MappingEditorDialog } = await import('./MappingEditor/MappingEditorDialog');

  return renderComponent({
    container,
    component: <MappingEditorDialog {...props} />,
    // TODO: previously we did it manually, need to test that it is still unmounts correctly
    autoUnmount: true,
  });
}
